import { OriginalSource } from '@prisma/client';

export function isSnapPart(originalSource: OriginalSource) {
  return originalSource === OriginalSource.SNAP;
}
